import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import "./Box.css";
import { activityService } from '../../../services/activityService';

export const Box = ({ activeItemId }) => {
  const [activities, setActivities] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchActivities = async () => {
      try {
        const data = await activityService.getActivities();
        setActivities(data.activities);
      } catch (error) {
        console.error('Ошибка загрузки активностей для меню:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchActivities();
  }, []);

  if (loading) {
    return (
      <div className="dropdown-menu">
        <div className="dropdown-content loading">
          <div className="loading-spinner"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="dropdown-menu">
      <div className="dropdown-content">
        {activities.map((activity) => (
          <Link
            key={activity.id}
            to={`/activity/${activity.slug}`}
            className={`dropdown-item ${activeItemId === activity.slug ? 'active' : ''}`}
          >
            <div className="text-wrapper">{activity.title}</div>
          </Link>
        ))}
      </div>
    </div>
  );
};